import React from "react";
import { useRefinementList } from "react-instantsearch";
import { getSwatchStyle } from "../../../Services/FacetedSearch.service";
import { translate } from "../../../Services/translation";
import { ColorRefinementListProps } from "./types/CustomRefinementListProps";
import { RefinementPanel } from "./Panel";

export const GetColorInfo = (itemValue: string) => {
  const colorInfo = itemValue.split(";");
  const label = colorInfo[0];
  const value = colorInfo.length > 1 ? colorInfo[1] : "#000000";

  return { label, value };
};

function ColorRefinementList(props: ColorRefinementListProps) {
  const {
    items,
    refine,
    canToggleShowMore,
    isShowingMore,
    toggleShowMore,
    isFromSearch,
  } = useRefinementList(props);
  const nothingToRefine = items.length <= 1 && !isFromSearch;

  return (
    <RefinementPanel
      {...props}
      className={`${nothingToRefine ? "hidden" : ""}`}
    >
      <ul className="algolia-color-refinement-list">
        {items.map((item) => {
          const { label, value } = GetColorInfo(item.value);

          return (
            <li
              key={item.value}
              className={`algolia-color-refinement-list__item ${
                item.isRefined
                  ? "algolia-color-refinement-list__item--checked"
                  : ""
              }`}
              data-insights-filter={`${props.attribute}:${item.value}`}
            >
              <label className="algolia-color-refinement-list__item__label">
                <input
                  type="checkbox"
                  className="algolia-color-refinement-list__item__label__checkbox"
                  onChange={() => refine(item.value)}
                  checked={item.isRefined}
                />
                <div
                  className={`algolia-color-refinement-list__item__label__color ${
                    ["#ffffff"].includes(value.toLocaleLowerCase())
                      ? "algolia-color-refinement-list__item__label__color--extra"
                      : ""
                  }`}
                  style={getSwatchStyle(value, item.isRefined)}
                ></div>
                <div className="algolia-color-refinement-list__item__label__text">
                  {label}
                </div>
              </label>
            </li>
          );
        })}
      </ul>
      <button
        onClick={toggleShowMore}
        disabled={!canToggleShowMore}
        className="algolia-refinement-list__more-button"
      >
        <span className="algolia-refinement-list__more-button__label">
          {isShowingMore
            ? translate("algolia.filters.show-less")
            : translate("algolia.filters.show-more")}
        </span>
      </button>
    </RefinementPanel>
  );
}

export default ColorRefinementList;
